import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styles from "./index.module.scss";
import dragIcon from "../../../../../assets/images/drag-icon.svg";
import editIcon from "../../../../../assets/images/edit-icon-pen.svg";
import NoTabsMessage from "../NoTabsMessage";

interface TabItem {
  title: string;
  permission?: string;
  order: number;
}

interface TemplateTabsNavigationProps {
  tabItems: TabItem[];
  activeTab: TabItem | null;
  onTabSelect: (tab: TabItem) => void;
  onTabsDragEnd: (result: any) => void;
  onEditTab: (tab: TabItem) => void;
  onAddTab: () => void;
  onAddFolder: () => void;
}

const TemplateTabsNavigation: React.FC<TemplateTabsNavigationProps> = ({
  tabItems,
  activeTab,
  onTabSelect,
  onTabsDragEnd,
  onEditTab,
  onAddTab,
  onAddFolder,
}) => {
  return (
    <div className={styles.templateTabsNav}>
      <div className={styles.buttonsContainer}>
        <div className={styles.addTabButton} onClick={onAddTab}>
          <div className={styles.addIcon}>+</div>
          <span>Add Tab</span>
        </div>
        <div 
          className={`${styles.addFolderButton} ${tabItems.length === 0 ? styles.disabledButton : ''}`} 
          onClick={tabItems.length > 0 ? onAddFolder : undefined}
        >
          <div className={styles.addIcon}>+</div>
          <span>Add Folder</span>
        </div>
      </div>
      <div className={`${styles.tabsContainer} col-12 col-md-10`}>
        {tabItems && tabItems.length > 0 ? (
          <DragDropContext onDragEnd={onTabsDragEnd}>
            <Droppable droppableId="tabs" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={`${styles.tabsDroppableArea} ${
                    snapshot.isDraggingOver ? styles.draggingOver : ""
                  }`}
                >
                  {tabItems
                    .sort((a, b) => a.order - b.order)
                    .map((tab, index) => (
                      <Draggable
                        key={tab.title}
                        draggableId={tab.title}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div className={`${styles.tabItemContainer} ${activeTab && activeTab.title === tab.title ? styles.activeTabContainer : ""}`}>
                            <div 
                              {...provided.dragHandleProps}
                              className={styles.dragHandle}
                            >
                              <img 
                                src={dragIcon} 
                                alt="Drag" 
                                className={styles.dragIcon} 
                              />
                            </div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className={`${styles.tabItem} ${
                                activeTab && activeTab.title === tab.title
                                  ? styles.activeTab
                                  : ""
                              } ${snapshot.isDragging ? styles.dragging : ""}`}
                              onClick={() => onTabSelect(tab)}
                            >
                              <div className={`${styles.tabPermissionTag} ${
                                tab.permission === 'Faculty' ? styles.programTeamOnly : 
                                tab.permission === 'None' ? styles.noOne : 
                                styles.all
                              }`}>
                                {tab.permission === 'Faculty' ? 'Program Team Only' : 
                                 tab.permission === 'None' ? 'No One' : 
                                 tab.permission || "All"}
                              </div>
                              <div className={styles.tabContent}>
                                <span className={styles.tabTitle}>{tab.title}</span>
                                <img 
                                  src={editIcon} 
                                  alt="Edit" 
                                  className={styles.editIcon}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onEditTab(tab);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <NoTabsMessage />
        )}
      </div>
    </div>
  );
};

export default TemplateTabsNavigation;
